<div class="nav-bar" style="height: 100vh; overflow: hidden;">

  <!-- TOP TOOLBAR -->
  <mat-toolbar class="d-flex justify-content-between align-items-center px-3 custom-toolbar-shadow top-toolbar" style="background-image: linear-gradient(to right, #9ccafb, #9ccafb);
           position: fixed; top: 0; left: 0; right: 0;
           z-index: 1001; color: rgb(37, 32, 97); padding: 0.5rem;">

    <div class="d-flex align-items-center toolbar-brand">
      <img [src]="logo" alt="Logo" style="height: 40px; width: 100px; margin-right: 6px;">
      <span (click)="navigateTo()" class="toolbar-company-name" style="cursor: pointer;">{{ companyText }}</span>
    </div>

    <div class="toolbar-page-title" *ngIf="currentDashboardTitle">
      {{ currentDashboardTitle }}
    </div>

    <div class="d-flex align-items-center gap-3 toolbar-actions">
      <img [src]="secondaryLogo" alt="Secondary Logo"
        style="height: 60px; width: 150px; margin-right: 6px; object-fit: contain; flex-shrink: 0;">
      <div class="toolbar-welcome">Welcome, {{ username }}</div>

      <button mat-icon-button class="logout-button" (click)="logout()" title="Logout" style="color: rgb(37, 32, 97);">
        <mat-icon>logout</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <!-- MAIN LAYOUT -->
  <mat-sidenav-container class="flex-1 h-full">

    <!-- SIDENAV -->
    <mat-sidenav [mode]="'side'" [opened]="true" class="sidenav position-fixed transition-all duration-300 ease-in-out"
      style="top: 60px;
             height: calc(100vh - 60px);
             background-color: #97c6f9;
             box-shadow: 4px 0 10px rgba(1,12,60,0.2);
             z-index: 1000;" [style.width.%]="isCollapsed ? 5 : 16">

      <div class="flex items-center justify-between px-3 pt-3">
        <button mat-icon-button (click)="toggleSidebar()" style="color: rgb(18,17,17);">
          <mat-icon>menu</mat-icon>
        </button>
      </div>

      <!-- MENU -->
      <mat-nav-list>
        <ng-container *ngFor="let item of menuItems">

          <!-- NO CHILD -->
          <a mat-list-item *ngIf="!hasChildren(item)" class="menuItems flex items-center px-4" [routerLink]="item.path"
            [ngClass]="{'active-item': isActive(item)}" [ngClass]="{'justify-center': isCollapsed}"
            [matTooltip]="item.name" matTooltipPosition="right">

            <mat-icon style="color: black;" class="pt-2">
              {{ item.icon }}
            </mat-icon>

            <span class="menu-item-label" style="padding-left:20px; color:black;" [ngClass]="{'hidden': isCollapsed}">
              {{ item.name }}
            </span>
          </a>

          <!-- WITH CHILD -->
          <ng-container *ngIf="hasChildren(item)">
            <a mat-list-item class="menuItems flex items-center px-4" (click)="toggleSubmenu(item.name, $event)"
              [ngClass]="{'justify-center': isCollapsed}" [matTooltip]="item.name" matTooltipPosition="right">

              <mat-icon style="color:black;" class="pt-2">
                {{ item.icon }}
              </mat-icon>

              <span class="menu-item-label" style="padding-left:20px; color:black;" [ngClass]="{'hidden': isCollapsed}">
                {{ item.name }}
              </span>

              <mat-icon *ngIf="!isCollapsed && item.name !== 'Quotes'" style="margin-left:auto;">
                {{ isMenuExpanded(item.name) ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </a>

            <!-- CHILD LIST -->
            <div *ngIf="isMenuExpanded(item.name) && !isCollapsed">
              <ng-container *ngFor="let child of item.children">

                <!-- Child without grandchildren -->
                <a mat-list-item *ngIf="!hasChildren(child)" class="menuItems child-menu px-4" [routerLink]="child.path"
                  [ngClass]="{'active-item': isActive(child)}" [matTooltip]="child.name" matTooltipPosition="right">

                  <mat-icon style="color:black;" class="pt-2">
                    {{ child.icon }}
                  </mat-icon>

                  <span class="menu-item-label" style="padding-left:20px; color:black;">
                    {{ child.name }}
                  </span>
                </a>

                <!-- Child with grandchildren -->
                <ng-container *ngIf="hasChildren(child)">
                  <a mat-list-item class="menuItems child-menu px-4" (click)="toggleSubmenu(child.name, $event)"
                    [matTooltip]="child.name" matTooltipPosition="right">

                    <mat-icon style="color:black;" class="pt-2">
                      {{ child.icon }}
                    </mat-icon>

                    <span class="menu-item-label" style="padding-left:20px; color:black;">
                      {{ child.name }}
                    </span>

                    <mat-icon *ngIf="child.name !== 'Manage Quotes'" style="margin-left:auto;">
                      {{ isMenuExpanded(child.name) ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                  </a>

                  <!-- Grandchild list -->
                  <div *ngIf="isMenuExpanded(child.name)" class="grandchild-menu">
                    <a mat-list-item *ngFor="let grandchild of child.children" class="menuItems grandchild-menu px-4"
                      [routerLink]="grandchild.path" [ngClass]="{'active-item': isActive(grandchild)}"
                      [matTooltip]="grandchild.name" matTooltipPosition="right">

                      <mat-icon style="color:black;" class="pt-2">
                        {{ grandchild.icon }}
                      </mat-icon>

                      <span class="menu-item-label" style="padding-left:40px; color:black;">
                        {{ grandchild.name }}
                      </span>
                    </a>
                  </div>
                </ng-container>

              </ng-container>
            </div>

          </ng-container>

        </ng-container>
      </mat-nav-list>

      <div class="macro-shortcut-container" *ngIf="canShowMacroShortcut()">
        <button #macroToggleButton type="button" class="macro-icon-button" (click)="toggleMacroPanel($event)"
          [matTooltip]="isCollapsed ? 'View Macros' : ''" matTooltipPosition="right" aria-label="View Macros">
          <mat-icon class="macro-icon-glyph">blur_on</mat-icon>
        </button>
      </div>

      <div #macroPanelElement *ngIf="canShowMacroShortcut() && isMacroPanelOpen" class="macro-panel"
        [ngClass]="{ 'expanded-sidebar': !isCollapsed }">
        <div class="macro-panel-header">Available Macros</div>

        <div class="macro-panel-state" *ngIf="isLoadingMacros || isLoadingMacroContent">
          Loading...
        </div>

        <div class="macro-panel-state error" *ngIf="macroErrorMessage">
          {{ macroErrorMessage }}
        </div>

        <div class="macro-list" *ngIf="!isLoadingMacros && !isLoadingMacroContent && macros.length > 0">
          <button type="button" class="macro-item" *ngFor="let macro of macros" (click)="selectMacro(macro)"
            [title]="macro">
            {{ macro }}
          </button>
        </div>

        <div class="macro-panel-state"
          *ngIf="!isLoadingMacros && !isLoadingMacroContent && macros.length === 0 && !macroErrorMessage">
          No macros found.
        </div>
      </div>
    </mat-sidenav>

    <!-- CONTENT -->
    <mat-sidenav-content class="bg-gray-100 transition-all duration-300 ease-in-out overflow-y-auto overflow-x-hidden"
      [style.marginLeft.%]="isCollapsed ? 5 : 16" [style.width.%]="isCollapsed ? 95 : 84"
      style="margin-top: 60px; height: calc(100vh - 60px);">

      <div [style.margin]="isChatRoute ? '0' : '1.5rem'" style="height:100%;">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>

  </mat-sidenav-container>
</div>